import { PropsWithChildren, TableHTMLAttributes } from "react";
import { cn } from "../../utils/cn";

export const Table = ({
  className,
  ...props
}: TableHTMLAttributes<HTMLTableElement>) => (
  <div className="overflow-hidden rounded-lg border border-slate-800">
    <table
      className={cn("w-full border-collapse bg-slate-950 text-sm text-slate-200", className)}
      {...props}
    />
  </div>
);

export const THead = ({ children }: PropsWithChildren) => (
  <thead className="bg-slate-900 text-xs uppercase tracking-wide text-slate-400">
    {children}
  </thead>
);

export const TBody = ({ children }: PropsWithChildren) => (
  <tbody className="divide-y divide-slate-800">{children}</tbody>
);

export const TR = ({ children, className }: PropsWithChildren<{ className?: string }>) => (
  <tr className={cn("transition hover:bg-slate-900/60", className)}>{children}</tr>
);

export const TH = ({ children, className }: PropsWithChildren<{ className?: string }>) => (
  <th className={cn("px-4 py-3 text-left font-medium", className)}>{children}</th>
);

export const TD = ({ children, className }: PropsWithChildren<{ className?: string }>) => (
  <td className={cn("px-4 py-3 align-middle", className)}>{children}</td>
);
